import $ from 'jquery'
import { ScrollSpy } from 'bootstrap'
import hcSticky from 'hc-sticky'

const dataSpyList = document.querySelectorAll('[data-bs-spy="scroll"]')

dataSpyList.forEach((dataSpyEl) => {
  ScrollSpy.getInstance(dataSpyEl)
})
document.addEventListener('activate.bs.scrollspy', (e) => {
  const headings = $('h2,h3,h4,h5,h6')
  const link = $(e.relatedTarget)
  const id = link.attr('href').replace(/^#+/, '')

  headings.removeClass('active')
  $(`#${id}`).addClass('active')
})

new hcSticky('#toc', {
  top: 30,
  responsive: {
    991: {
      disable: true,
    },
  },
})
